import { BusinessDocument } from "@/types/business";
import { getDocumentDisplayStatus } from "./constants";

const DocumentStatusBadge = ({ doc }: { doc: BusinessDocument }) => {
  const { label, className } = getDocumentDisplayStatus(doc);
  return (
    <span
      className={`shrink-0 px-3 py-1 rounded-full text-[11px] font-bold tracking-wide uppercase border ${className}`}
    >
      {label}
    </span>
  );
};

export default DocumentStatusBadge;
